<template>
  <nav class="cs-nav">
    <div class="cs-nav-inner">
      <router-link to="/" class="cs-logo">
        <div class="logoBlack"></div>
      </router-link>
      <span class="cs-mobile-toggle" @click="mobileOpen=!mobileOpen">☰</span>
      <ul class="cs-nav-links" :class="{'cs-nav-open':mobileOpen}">
        <li><span class="cs-nav-a" @click="go('/#platform')">赋能中台</span></li>
        <li><span class="cs-nav-a" @click="go('/#solutions')">AI内容</span></li>
        <li><span class="cs-nav-a" @click="go('/#cases')">案例</span></li>
        <li><span class="cs-nav-a" @click="go('/#ecosystem')">腾讯生态</span></li>
        <li class="cs-nav-dropdown">
          <span class="cs-nav-a cs-dropdown-toggle">关于我们 ▾</span>
          <ul class="cs-dropdown-menu">
            <li><span class="cs-nav-a" @click="go('/#honors')">资质荣誉</span></li>
            <li><span class="cs-nav-a" @click="go('/#partners')">合作伙伴</span></li>
            <li><span class="cs-nav-a" @click="go('/#news')">公司动态</span></li>
          </ul>
        </li>
        <li><span class="cs-cta-btn" @click="go('/#contact')">合作咨询</span></li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  data(){return{mobileOpen:false}},
  computed:{
    routeName(){return this.$route.matched[0]?.name}
  },
  watch:{
    $route(){this.mobileOpen=false}
  },
  methods:{
    go(anchor){
      const hash=anchor.split('#')[1]
      if(this.$route.path==='/'){
        const el=document.getElementById(hash)
        if(el) el.scrollIntoView({behavior:'smooth'})
      }else{
        this.$router.push('/')
        this.$nextTick(()=>{
          const el=document.getElementById(hash)
          if(el) el.scrollIntoView({behavior:'smooth'})
        })
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../../assets/styles/mixins.styl';

/* 导航栏 */
.cs-nav
  position: fixed
  top: 0
  width: 100%
  z-index: 100
  background: rgba(245,243,238,.94)
  backdrop-filter: blur(12px)
  border-bottom: 1px solid #D9D6CE

.cs-nav-inner
  max-width: 1160px
  margin: 0 auto
  padding: 0 36px
  display: flex
  justify-content: space-between
  align-items: center
  height: 64px

/* Logo */
.cs-logo
  display: flex
  align-items: center
  text-decoration: none
  flex-shrink: 0

.logoBlack
  width: 196px
  max-width: 35vw
  height: 48px
  max-height: 100%
  background-repeat: no-repeat
  background-size: contain
  background-image: url('~@/assets/newImages/companyIcon.png')
  background-position: left center

@media (max-width: 768px)
  .logoBlack
    width: 140px
    height: 38px

/* 导航链接 */
.cs-nav-links
  display: flex
  gap: 28px
  list-style: none
  align-items: center
  margin: 0
  padding: 0
  a, .cs-nav-a
    color: #787671
    font-size: 13px
    font-weight: 500
    text-decoration: none
    transition: color .2s
    cursor: pointer
    &:hover
      color: #141413

/* CTA 按钮 */
.cs-cta-btn
  padding: 7px 18px
  background: #D97757
  color: #fff !important
  border-radius: 20px
  font-size: 13px
  font-weight: 600
  &:hover
    background: #C56A4A
    color: #fff !important

/* 下拉菜单 */
.cs-nav-dropdown
  position: relative
  .cs-dropdown-toggle
    cursor: pointer
  .cs-dropdown-menu
    display: none
    position: absolute
    top: 100%
    left: 0
    min-width: 140px
    background: #fff
    border: 1px solid #D9D6CE
    border-radius: 6px
    box-shadow: 0 4px 16px rgba(0,0,0,.08)
    padding: 8px 0
    list-style: none
    z-index: 110
    a
      display: block
      padding: 8px 18px
      font-size: 13px
      color: #787671
      white-space: nowrap
      &:hover
        background: #F5F3EE
        color: #141413
  &:hover .cs-dropdown-menu
    display: block

/* 移动端 */
.cs-mobile-toggle
  display: none
  font-size: 20px
  color: #141413
  cursor: pointer

@media (max-width: 768px)
  .cs-mobile-toggle
    display: block
  .cs-nav-links
    display: none
    &.cs-nav-open
      display: flex
      flex-direction: column
      position: absolute
      top: 64px
      left: 0
      width: 100%
      background: rgba(245,243,238,.98)
      border-bottom: 1px solid #D9D6CE
      padding: 16px 36px
      gap: 12px
      a
        font-size: 15px
  .cs-nav-dropdown .cs-dropdown-menu
    position: static
    box-shadow: none
    border: none
    padding-left: 16px
  .cs-nav-dropdown:hover .cs-dropdown-menu
    display: block
</style>
